import { render, staticRenderFns } from "./AddInsuranceCompany.vue?vue&type=template&id=cdaea4c4&scoped=true"
import script from "./AddInsuranceCompany.vue?vue&type=script&lang=js"
export * from "./AddInsuranceCompany.vue?vue&type=script&lang=js"
import style0 from "./AddInsuranceCompany.vue?vue&type=style&index=0&id=cdaea4c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdaea4c4",
  null
  
)

export default component.exports